import moment = require("moment");
import * as React from "react";
import DatePicker from "react-datepicker";
import {DateRange} from "../../../../../../components/rangeddatepicker/RangedDatePickerController";
import {I18n} from "../../../../../../components/Utils/i18n";
import {removeHours, removeMinutes} from "./MaintenanceFormUtils";

export interface NewMaintenanceFormData {
    date: Date;
}

export interface NewMaintenanceFormProps {
    onDataChange: (newDate: NewMaintenanceFormData) => void;
    dateLabel: string;
    dateInteval: DateRange;
}

export interface NewMaintenanceFormState {
    newMaintenanceInfo: NewMaintenanceFormData;
}

declare var LOCALE: string;

export class NewMaintenanceForm extends React.Component<NewMaintenanceFormProps, NewMaintenanceFormState> {

    constructor(props) {
        super(props);
        const info: NewMaintenanceFormData = {
            date: new Date(),
        };
        this.state = {
            newMaintenanceInfo: info,
        };
    }

    public componentDidMount() {
        this.props.onDataChange(this.state.newMaintenanceInfo);
    }

    public render() {

        const selectedDate: Date = removeMinutes(this.state.newMaintenanceInfo.date);

        const selecteDateDay: Date = removeHours(selectedDate);

        const minTime: Date =
            this.props.dateInteval.start
                ? (removeHours(selectedDate).getTime() === removeHours(this.props.dateInteval.start).getTime())
                    ? this.props.dateInteval.start
                    : moment().startOf("day").toDate()
                : moment().startOf("day").toDate();

        const maxTime: Date =
            this.props.dateInteval.end
                ? (removeHours(selectedDate).getTime() === removeHours(this.props.dateInteval.end).getTime())
                    ? this.props.dateInteval.end
                    : moment().endOf("day").toDate()
                : moment().endOf("day").toDate();

        return (
            <div className={"new-maintenance-popup-form"}>
                <div className={"new-maintenance-popup-form-date"}>
                    <label>{this.props.dateLabel}</label>
                    <DatePicker
                        selected={selectedDate}
                        onChange={this.onMaintenanceDateChange}
                        showTimeSelect={true}
                        timeIntervals={60}
                        timeFormat="HH:mm"
                        minDate={this.props.dateInteval.start}
                        minTime={minTime}
                        maxDate={this.props.dateInteval.end}
                        maxTime={maxTime}
                        dateFormat={I18n.getLocaleDateFormat(LOCALE) + " HH:mm"}
                        // locale={LOCALE}
                    />
                </div>
            </div>
        );
    }

    private onMaintenanceDateChange = (newDate: Date) => {
        if (
            removeHours(newDate).getTime() < removeHours(this.props.dateInteval.start).getTime()
            || removeHours(newDate).getTime() > removeHours(this.props.dateInteval.end).getTime()
        ) {
            return;
        }
        this.setState({
            ...this.state,
            newMaintenanceInfo: {
                ...this.state.newMaintenanceInfo,
                date: newDate,
            },
        }, () => {
            this.props.onDataChange(this.state.newMaintenanceInfo);
        });
    }
}
